import {
  REQUEST_VEHICLE_SUCCESS,
  REQUEST_VEHICLE_FAILED,
  SET_VEHICLE,
  UPDATE_SEARCHED_VEHICLE,
  GET_MAKES_SUCCESS,
  GET_MODELS_SUCCESS,
  GET_VARIANTS_SUCCESS,
  CREATE_UNKNOWN_VEHICLE_SUCCESS,
  UNKNOWN_VEHICLE_REG_SUCCESS,
  SET_VEHICLE_SEARCHED_REG,
  SET_VEHICLE_ERROR,
  UPDATE_VEHICLE_VALUE,
  SET_VEHICLE_TYPE,
  UPDATE_GROSS_WEIGHT,
  UPDATE_YEAR_OF_MANUFACTURE,
  COMMERCIAL_VEHICLE,
  COMMERCIAL_VEHICLE_WEIGHT_BREAKPOINT,
} from './constants'
import { REQUEST_QUOTE_SUCCESS, CREATE_QUOTE_SUCCESS } from '../App/constants'
import { REQUEST_CREATE_UNKNOWN_VEHICLE_SUCCESS } from '../UnknownRegPage/constants'
import initialState from '../../initialState'
import {
  REQUEST_POLICY_SUCCESS,
  GET_ANALYSIS_DATA_SUCCESS,
} from '../PolicyConfirmationPage/constants'
import {
  VEHICLE_VALUES,
  blankVehicleValue,
  hasVehicleValue,
} from '../../components/VehicleValue/constants'
import moment from 'moment'

// VehicleValueBandId is always populated with a default band (e.g. 5, the
// lowest) even when no real estimate exists - VehicleValueBand is the only
// field that is null when the value is genuinely unset. Treat that null as
// authoritative and skip the BandId lookup entirely, falling back to
// whatever the customer has already told us before blanking the field.
const vehicleValueFromBand = (bandId, vehicleValueBand, existing) => {
  const fallback = hasVehicleValue(existing) ? existing : blankVehicleValue()
  if (vehicleValueBand === null) {
    return fallback
  }
  return (
    VEHICLE_VALUES.find((vehicleValue) => vehicleValue.value === bandId) ||
    fallback
  )
}

function vehicleReducer(state = initialState.vehicle, action) {
  switch (action.type) {
    case UPDATE_SEARCHED_VEHICLE:
      let vehicle = action.vehicle
      return {
        ...state,
        searched: {
          ...state.searched,
          ...vehicle,
          VehicleBuilt: false,
          VehicleFound: false,
        },
        error: vehicle.RegistrationNumber ? null : state.error,
      }
    case REQUEST_VEHICLE_SUCCESS:
    case REQUEST_CREATE_UNKNOWN_VEHICLE_SUCCESS:
      vehicle = action.vehicle
      return {
        ...state,
        searched: {
          ...state.searched,
          VehicleId: vehicle.VehicleId,
          RegistrationNumber: vehicle.RegistrationNumber,
          Make: vehicle.Make,
          Model: vehicle.Model,
          VehicleType:
            vehicle.VehicleType === 'Motorcycle'
              ? 'Motorbike'
              : vehicle.VehicleType,
          Abi: vehicle.Abi,
          MakeAndModel: vehicle.MakeAndModel,
          DateFirstRegistered: vehicle.DateFirstRegistered,
          vehicleValue: vehicleValueFromBand(
            vehicle.VehicleValueBandId,
            vehicle.VehicleValueBand
          ),
          VehicleFound: true,
          Variant: null,
        },
        error: null,
      }
    case REQUEST_QUOTE_SUCCESS:
      vehicle = action.quote.Vehicle
      return {
        ...state,
        selected: {
          ...state.selected,
          VehicleId: vehicle.VehicleId,
          RegistrationNumber: vehicle.Registration,
          Make: vehicle.Make,
          Model: vehicle.Model,
          Abi: vehicle.Abi,
          VehicleType:
            (vehicle.VehicleType === 'Motorcycle'
              ? 'Motorbike'
              : vehicle.VehicleType) || null,
          vehicleValue: vehicleValueFromBand(
            action.quote.VehicleValueBandId,
            action.quote.VehicleValueBand,
            state.selected.vehicleValue
          ),
          YearOfManufacture:
            vehicle.DateOfManufacture === null
              ? null
              : moment(vehicle.DateOfManufacture).year(),
          GrossWeight: vehicle.GrossWeight,
          Impounded: vehicle.Impounded,
        },
        searched: {
          ...state.searched,
          VehicleId: vehicle.VehicleId,
          RegistrationNumber: vehicle.Registration,
          VehicleType:
            (vehicle.VehicleType === 'Motorcycle'
              ? 'Motorbike'
              : vehicle.VehicleType) || null,
        },
        error: null,
      }
    case CREATE_UNKNOWN_VEHICLE_SUCCESS:
      vehicle = action.vehicle
      return {
        ...state,
        searched: {
          ...state.searched,
          VehicleId: vehicle.VehicleId,
          VehicleBuilt: true,
          // A manually built vehicle has no valuation, so prompt for one rather
          // than silently assuming the lowest band.
          vehicleValue: blankVehicleValue(),
        },
      }
    case SET_VEHICLE:
      vehicle = action.vehicle
      if (
        vehicle &&
        vehicle.VehicleType === COMMERCIAL_VEHICLE &&
        vehicle.GrossWeight > COMMERCIAL_VEHICLE_WEIGHT_BREAKPOINT
      ) {
        vehicle = {
          ...vehicle,
          Make: null,
          Model: null,
          Variant: null,
        }
      }

      return {
        ...state,
        searched: {
          ...state.searched,
        },
        selected: vehicle,
      }
    case REQUEST_VEHICLE_FAILED:
      return {
        ...state,
        searched: {
          ...state.searched,
          RegistrationNumber: action.registrationNumber,
          VehicleId: null,
          Make: null,
          Model: null,
          VehicleType: '',
          Abi: null,
          MakeAndModel: null,
          DateFirstRegistered: null,
          VehicleFound: false,
          Variant: null,
          VehicleBuilt: null,
        },
        error: action.error,
      }
    case GET_MAKES_SUCCESS:
      return {
        ...state,
        makes: action.makes,
        models: [],
        variants: [],
      }
    case GET_MODELS_SUCCESS:
      return {
        ...state,
        models: action.models,
        variants: [],
      }
    case GET_VARIANTS_SUCCESS:
      return {
        ...state,
        variants: action.variants,
      }
    case UNKNOWN_VEHICLE_REG_SUCCESS:
      return {
        ...state,
        searched: {
          ...state.searched,
          Make: action.manualVehicle.Make,
          Model: action.manualVehicle.Model,
          VehicleType: action.manualVehicle.VehicleType,
        },
        selected: {
          ...state.selected,
          VehicleId: action.builtVehicle.VehicleId,
          Make: action.manualVehicle.Make,
          Model: action.manualVehicle.Model,
          Abi: action.manualVehicle.Variant,
          VehicleType: action.manualVehicle.VehicleType,
          GrossWeight: action.manualVehicle.GrossWeight,
          YearOfManufacture: action.manualVehicle.YearOfManufacture,
          Impounded: action.manualVehicle.Impounded,
        },
      }
    case REQUEST_POLICY_SUCCESS:
      return {
        ...state,
        selected: {
          ...state.selected,
          Make: action.policy.VehicleSummary.Make,
          Model: action.policy.VehicleSummary.Model,
          RegistrationNumber: action.policy.VehicleSummary.Registration,
          VehicleType: action.policy.VehicleSummary.VehicleType,
        },
      }
    case SET_VEHICLE_SEARCHED_REG:
      return {
        ...state,
        searched: {
          ...state.searched,
          RegistrationNumber: action.vehicleReg,
          VehicleType: action.vehicleType || null,
          VehicleFound: action.vehicleType ? true : false,
        },
      }
    case SET_VEHICLE_ERROR:
      return {
        ...state,
        error: action.error,
      }
    case CREATE_QUOTE_SUCCESS:
      return {
        ...state,
        selected: {
          ...state.selected,
          vehicleValue: vehicleValueFromBand(
            action.quote.VehicleValueBandId,
            action.quote.VehicleValueBand,
            state.selected.vehicleValue
          ),
        },
      }
    case UPDATE_VEHICLE_VALUE:
      return {
        ...state,
        selected: {
          ...state.selected,
          vehicleValue: action.value,
        },
      }
    case SET_VEHICLE_TYPE:
      return {
        ...state,
        searched: {
          ...state.searched,
          VehicleType: action.vehicleType,
          Abi: null,
          Model: null,
          Make: '',
          VehicleBuilt: null,
          Variant: null,
          GrossWeight: null,
          YearOfManufacture: null,
        },
      }
    case GET_ANALYSIS_DATA_SUCCESS:
      return {
        ...state,
        scheme: action.response.Scheme,
      }
    case UPDATE_GROSS_WEIGHT:
      return {
        ...state,
        searched: {
          ...state.searched,
          GrossWeight: action.grossWeight,
        },
      }
    case UPDATE_YEAR_OF_MANUFACTURE:
      return {
        ...state,
        searched: {
          ...state.searched,
          YearOfManufacture: action.yearOfManufacture,
        },
      }
    default:
      return state
  }
}

export default vehicleReducer
